import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { getters } from './getters';
import actions from './actions';
import { mutations } from './mutations';
import { JsonClient } from '@/util/JsonClient';
import { EmptyBulkState, BulkState } from './types';

export class BulkModule implements Module<BulkState, RootState> {
    public readonly namespaced: boolean = true;
    public readonly state: BulkState;
    public readonly actions: ActionTree<BulkState, RootState>;
    public readonly getters: GetterTree<BulkState, RootState>;
    public readonly mutations: MutationTree<BulkState>;

    constructor(backend: JsonClient) {
        this.actions = actions(backend);
        this.mutations = mutations;
        this.getters = getters;
        this.state =  EmptyBulkState();
    }
}


